var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7887 0.705047C9.95142 0.542328 10.2152 0.542328 10.378 0.705047L15.378 5.70505C15.5407 5.86777 15.5407 6.13158 15.378 6.2943L10.378 11.2943C10.2152 11.457 9.95142 11.457 9.7887 11.2943C9.62599 11.1316 9.62599 10.8678 9.7887 10.705L14.0774 6.41635L0.916669 6.41642C0.68655 6.41642 0.500001 6.22987 0.5 5.99975C0.499999 5.76963 0.686546 5.58308 0.916664 5.58308L14.0774 5.58301L9.7887 1.2943C9.62599 1.13158 9.62599 0.867765 9.7887 0.705047Z",
    fill: "#2167AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.bffa6a3086db38a506a27f450bfa9569.svg";
export { ForwardRef as ReactComponent };